(function ($, Drupal) {
  Drupal.behaviors.link_button = {
    attach: function attach(context) {
      const selector = '[data-component-id="nuplayer:link_button"]';
      once('link-button--processed', selector, context).forEach((button) => {
        $(button).on('click', function () {
          const $button = $(this);
          const $text = $button.find('.link_button--text');
          const defaultText = $button.data('text-default');
          const toggledText = $button.data('text-toggled');
          const $sibling = $button.prev();
          const $extended = $button.prev('.extended-desc');
          const expanded = $button.attr('aria-expanded') === 'true';

          $button.attr('aria-expanded', expanded ? 'false' : 'true');

          if ($sibling.length) {
            $sibling.prop('hidden', expanded);
          }

          if (toggledText) {
            $text.text(!expanded ? toggledText : defaultText);
          }

          $extended.prop('hidden', expanded);
        });
      });
    },
  };
})(jQuery, Drupal);
